module.exports = __webpack_public_path__ + "eab178c247f42fc4cfa44eb3170668c0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/large-6.png
// module id = 1583
// module chunks = 0